import { produce } from 'immer';

import { StoreHelper } from '@helpers';

export enum CookieName {
	ResponseType = 'ResponseType',
	Response = 'Response',
}

export type CookieResponseTypeCode =
	| 'serviceUnavailable'
	| 'invalidCredentials'
	| 'updateCredentials'
	| 'invalidUpdateCredentials'
	| 'invalidCaptcha';

export interface CookiesState {
	responseType?: CookieResponseTypeCode;
	response?: string;
}

export const initialCookiesState: CookiesState = {};

interface UseCookiesStoreOutput extends CookiesState {
	setState: (state: CookiesState) => void;
}

export const useCookiesStore = StoreHelper.createStore<UseCookiesStoreOutput>(
	(set) => ({
		...initialCookiesState,
		setState: function (state: CookiesState) {
			set(
				produce((currentState: CookiesState) => ({
					...currentState,
					...state,
				})),
				false,
				'setState'
			);
		},
	}),
	{
		name: 'Cookies',
	}
);
